import {
  RESET_CHANNEL,
  UPDATE_CHANNEL_WHATSAPP_STATUS,
  UPDATE_CHANNEL_VOICE_STATUS,
  CONNECT_CHAT_VISOR,
  UPDATE_WHATSAPPS_ON_HOLD,
  SET_VOICE_ON_HOLD,
  UPDATE_CHAT_ON_HOLD,
} from '../../mutation-types';
import { connect as connectChatVisor } from '@/services/chat-visor-service';

const actions = {
  async connectChatVisor({ commit }, agentId) {
    try {
      const action = { agentId };
      await connectChatVisor(action);

      commit(CONNECT_CHAT_VISOR);
    } catch (err) {
      window.console.log(err);
    }
  },

  updateChatsOnHold({ commit }, chatOnHold) {
    commit(UPDATE_CHAT_ON_HOLD, chatOnHold);
  },

  updateStatusWhatsapp({ dispatch }, status) {
    dispatch('updateStatusWhatsApp', status);
  },

  updateStatusWhatsApp({ commit }, status) {
    commit(UPDATE_CHANNEL_WHATSAPP_STATUS, status);
  },

  updateWhatsAppsOnHold({ commit }, whatsAppOnHolds) {
    commit(UPDATE_WHATSAPPS_ON_HOLD, whatsAppOnHolds);
  },

  setVoiceOnHold({ commit }, voiceOnHold) {
    commit(SET_VOICE_ON_HOLD, voiceOnHold);
  },

  updateStatusVoice({ commit }, status) {
    commit(UPDATE_CHANNEL_VOICE_STATUS, status);
  },

  updateStatusChannels({ dispatch }, channelsStatus) {
    Object.entries(channelsStatus).forEach(([channel, status]) => {
      const firstLetterChannel = channel.charAt(0).toUpperCase();
      const remaining = channel.slice(1);

      const channelName = `${firstLetterChannel}${remaining}`;
      const action = `updateStatus${channelName}`;

      dispatch(action, status);
    });
  },

  reset({ commit }) {
    commit(RESET_CHANNEL);
  },

  alterStatusByChannel({ dispatch }, { channel, status }) {
    const firtWordUpperCase = channel.charAt(0).toUpperCase();
    const remainingChannelName = channel.slice(1);
    const channelName = `${firtWordUpperCase}${remainingChannelName}`;
    const action = `updateStatus${channelName}`;

    dispatch(action, status);
  },
};

export default actions;
